import styled, { keyframes } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const breatheAnimation = keyframes`
  0% {
    transform: translateX(104px);
  }
  10%, 40%, 50%, 60%, 95% {
    width: 170px;
    transform: translateX(0px);
  }
  100% {
    transform: translateX(104px);
  }
`;

export const MainContainer = styled.div`
    position: absolute;
    right: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    overflow: hidden;
    align-self: baseline;
`;

export const ChangeButtonWrapper = styled.div`
    margin: 0 8px 1px 0;
    overflow: hidden;
`;

export const ChangePaymentCtaContainerV2 = styled(Text)<{ isLongText: boolean }>`
    background: linear-gradient(275deg, #FFF 91.10%, rgba(255, 255, 255, 0.00) 99.27%);
    white-space: nowrap;
    ${props => (props.isLongText ? "transform: translateX(104px); margin-right: -2px;" : "margin-right: 0px;")}
    animation: ${props => (props.isLongText ? breatheAnimation : "none")} 5s linear;
    animation-delay: 2s;
    animation-fill-mode: forwards;
    padding-left: 12px;
`;
